// Curated 1-click Apify actor presets for our highest-ROI verticals.
// Each recipe pre-fills the "Run Actor" form: actor_id, input JSON and a
// niche label. Users can still tweak the JSON before firing.
//
// Actor picks:
// • compass/crawler-google-places — best coverage for local biz (name,
//   phone, website, rating, reviews_count, address). Free to run.
// • drobnikj/crawler-google-places — legacy fallback (same shape).

export const APIFY_RECIPES = [
  {
    id: "wedding-venues-usa",
    label: "Wedding venues · USA",
    hint: "Top 100 wedding venues nationwide, pre-mapped to owner phone/website.",
    actor_id: "compass/crawler-google-places",
    niche: "wedding venue",
    max: 100,
    input: {
      searchStringsArray: ["wedding venue"],
      locationQuery: "United States",
      maxCrawledPlacesPerSearch: 100,
      language: "en",
    },
  },
  {
    id: "med-spas-tx-reviewed",
    label: "Med spas · TX · 20+ reviews",
    hint: "Texas med spas with a track record — trailing reviews prove they can afford us.",
    actor_id: "compass/crawler-google-places",
    niche: "med spa",
    max: 100,
    input: {
      searchStringsArray: ["med spa", "medical spa"],
      locationQuery: "Texas, USA",
      maxCrawledPlacesPerSearch: 100,
      language: "en",
      // Filter is applied client-side in our lead pipeline via `min_reviews`.
      minimumStars: 4,
    },
  },
  {
    id: "dental-clinics-ca",
    label: "Dental clinics · California",
    hint: "Cosmetic + general dental — high-ticket AOV, phone-forward buyers.",
    actor_id: "compass/crawler-google-places",
    niche: "dental clinic",
    max: 75,
    input: {
      searchStringsArray: ["dental clinic", "cosmetic dentist"],
      locationQuery: "California, USA",
      maxCrawledPlacesPerSearch: 75,
      language: "en",
    },
  },
  {
    id: "hvac-usa",
    label: "HVAC contractors · USA",
    hint: "Local HVAC shops — great fit for SMS + call cadence, night-time emergencies.",
    actor_id: "compass/crawler-google-places",
    niche: "HVAC contractor",
    max: 100,
    input: {
      searchStringsArray: ["HVAC contractor", "air conditioning repair"],
      locationQuery: "United States",
      maxCrawledPlacesPerSearch: 100,
      language: "en",
    },
  },
  {
    id: "roofing-fl",
    label: "Roofing companies · Florida",
    hint: "Post-hurricane demand — roofers with real phones + Google reviews.",
    actor_id: "compass/crawler-google-places",
    niche: "roofing",
    max: 75,
    input: {
      searchStringsArray: ["roofing company", "roof repair"],
      locationQuery: "Florida, USA",
      maxCrawledPlacesPerSearch: 75,
      language: "en",
    },
  },
  {
    id: "law-firms-ny",
    label: "Law firms · NYC",
    hint: "Small/mid law firms in NYC — recurring high-ticket clients, phone-driven intake.",
    actor_id: "compass/crawler-google-places",
    niche: "law firm",
    max: 75,
    input: {
      searchStringsArray: ["law firm", "personal injury lawyer"],
      locationQuery: "New York, NY, USA",
      maxCrawledPlacesPerSearch: 75,
      language: "en",
    },
  },
];
